/**
 * The start of the school year: 1 August as a canonical calendar day (00:00:00.000 UTC, see
 * `@adornis/datetime/calendarDay.js`). Day-precision fields are stored canonically, so `<`/`>=`
 * against this value bucket them exactly — no zone, no fudge.
 *
 * `Date.UTC` rather than a `TZDate` pinned to `Etc/UTC`: a calendar day has no zone to resolve, and
 * the result has to be a plain `Date` because these bounds end up in Mongo queries and on booking
 * entities, where a `TZDate` would serialize to `+00:00` instead of `Z`.
 */
export const getSchoolYearTippingPoint = (year: number): Date => new Date(Date.UTC(year, 7, 1));
